import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import messages from 'components/Apps/EnvironmentMonitor/translate'
import SelectList from 'components/common/SelectList'
import { fetchSiteList } from 'reducers/dashboard/growth/reducer'
import { setSiteContext } from 'reducers/profile/reducer'
import ArrayHelper from 'helpers/array'
import { logMonitorActivity } from 'reducers/environmentMonitor/reducer'
import { EVENT_TYPES } from 'routes/App/Apps/MonitorsAndAlerts/logTypes'
import ViewTypeMenu from './ViewTypeMenu'

class EnvFilterBar extends Component {
  componentDidMount() {
    this.props.fetchSiteList()
  }

  shouldComponentUpdate(nextProps) {
    const { siteList, setSiteContext } = this.props
    const { siteList: nextSiteList, activeSite } = nextProps

    if (siteList !== nextSiteList && nextSiteList.size > 0) {
      const isActiveSiteHasAnId = ArrayHelper.hasInArray(
        nextSiteList.toArray(),
        activeSite,
        'id',
      )

      if (activeSite === 0 || (activeSite !== 0 && !isActiveSiteHasAnId)) {
        const activeSite = nextSiteList.get(0)
        setSiteContext({ site: activeSite.id })

        return false
      }
    }

    return true
  }

  onSiteChange = value => {
    if (value) {
      const { siteList, activeSite, setSiteContext } = this.props
      const siteId = siteList.get(value.mapKey).id

      if (activeSite !== value.index) {
        const {
          logMonitorActivity,
          activeViewType,
          currentApp: { id: licenseeApplicationId, applicationId },
          history: {
            location: { pathname },
          },
        } = this.props
        const logData = {
          licensee_application: licenseeApplicationId,
          application: applicationId,
          site: siteId,
          event_name: EVENT_TYPES.SITE_FILTER,
          tab_name: activeViewType,
          application_url: pathname,
          referrer: null,
        }

        setSiteContext({ site: siteId })
        logMonitorActivity(logData)
      }
    }
  }

  render() {
    const {
      intl: { formatMessage },
      siteList,
      activeSite,
      currentApp,
    } = this.props

    return (
      <Grid container spacing={2}>
        <Grid item lg={2} md={3} sm={6} xs={12}>
          <SelectList
            name="site"
            label={formatMessage(messages.siteList)}
            onChange={this.onSiteChange}
            list={siteList}
            value={activeSite}
            map={{
              index: 'id',
              text: 'name',
            }}
          />
        </Grid>
        <Grid item lg={10} md={9} sm={6} xs={12}>
          <ViewTypeMenu currentApp={currentApp} />
        </Grid>
      </Grid>
    )
  }
}

export default withRouter(
  connect(
    state => ({
      siteList: state.getIn(['dashboardGrowth', 'siteList']),
      activeSite: state.getIn(['profile', 'siteId']),
      activeViewType: state.getIn(['environmentMonitor', 'viewType']),
    }),
    {
      fetchSiteList,
      setSiteContext,
      logMonitorActivity,
    },
  )(injectIntl(EnvFilterBar)),
)
